import { formatCurrency } from 'toolbox/format'
import DataPoint from '../common/DataPoint'
import InfoPoint from '../common/InfoPoint'

export interface RewardItem {
  poolAsset: string
  rewardAsset: string
  unclaimedTokens: number
  unclaimedUSD: number
}

export interface ClaimRewardsProps {
  totalClaimAmount: number
  supplyRewards: RewardItem[]
  borrowRewards: RewardItem[]
  onClaim: () => void
  disabled?: boolean
  isLoading?: boolean
}

export function ClaimRewards({
  totalClaimAmount,
  supplyRewards,
  borrowRewards,
  onClaim,
  disabled = false,
  isLoading = false
}: ClaimRewardsProps) {
  return (
    <div className="claim-rewards">
      <div className="claim-rewards__header">
        <InfoPoint value="Claim Your Rewards" sub={''} />
      </div>

      <div className="claim-rewards__amount">
        <DataPoint label="You receive" value={`${totalClaimAmount.toFixed(2)} MOVE`} large />
      </div>

      {/* Supply Rewards */}
      {supplyRewards.length > 0 && (
        <div className="claim-rewards__section">
          <h3>Supply Rewards</h3>
          <div className="claim-rewards__list">
            {supplyRewards.map((reward, index) => (
              <div key={index} className="claim-rewards__item">
                <div className="claim-rewards__item-asset">
                  <span className="asset-name">{reward.poolAsset}</span>
                </div>
                <div className="claim-rewards__item-amount">
                  <span className="token-amount">
                    {reward.unclaimedTokens.toFixed(2)} {reward.rewardAsset}
                  </span>
                  <span className="usd-amount">{formatCurrency(reward.unclaimedUSD)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Borrow Rewards */}
      {borrowRewards.length > 0 && (
        <div className="claim-rewards__section">
          <h3>Borrow Rewards</h3>
          <div className="claim-rewards__list">
            {borrowRewards.map((reward, index) => (
              <div key={index} className="claim-rewards__item">
                <div className="claim-rewards__item-asset">
                  <span className="asset-name">{reward.poolAsset}</span>
                </div>
                <div className="claim-rewards__item-amount">
                  <span className="token-amount">
                    {reward.unclaimedTokens.toFixed(2)} {reward.rewardAsset}
                  </span>
                  <span className="usd-amount">{formatCurrency(reward.unclaimedUSD)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="claim-rewards__button">
        <button
          className="sp-btn primary large full-w"
          onClick={onClaim}
          disabled={disabled || isLoading}>
          {isLoading ? 'Claiming...' : 'Claim Rewards'}
        </button>
      </div>

      <p className="claim-rewards__disclaimer">
        By clicking Claim, I authorize MovePosition to supply the above rewards to my portfolio
      </p>
    </div>
  )
}
